export default __webpack_public_path__ + "static/media/II_Old_White.4a3ff0f0.png";